module.exports = __webpack_public_path__ + "static/media/community-message.22049286.jpg";